import { useEffect, useState } from "react";
import { useContentful } from "../../hooks";
import { TutorialStep } from "../TutorialStep/TutorialStep"
import { LoadingTutorialBgStyled, LoadingTutorialWrapper } from "./LoadingTutorial.styled"

export const LoadingTutorial = () => {
  const { tutorials } = useContentful();
  const [tutorialIndex, setTutorialIndex] = useState(-1);
  const tutorial = tutorials?.[tutorialIndex];
  
  const totalLength = tutorials?.length || 0;

  const randomTutorialIndex = (omitIndex) => {
    if (totalLength < 2) {
      return 0;
    }
    let randomIndex = Math.floor(Math.random() * totalLength);
    if (randomIndex === omitIndex) {
      randomIndex = randomIndex === 0 ? 1 : 0;
    }
    return randomIndex;
  };

  useEffect(() => {
    let interval = setInterval(() => setTutorialIndex(index => randomTutorialIndex(index)), 4000);
    setTutorialIndex(index => randomTutorialIndex(index));
    return () => clearInterval(interval);
  }, [tutorials]);

  return (<LoadingTutorialWrapper>
    {!(tutorial?.image) && <LoadingTutorialBgStyled>
      <img src='/assets/item_bg.png' />
    </LoadingTutorialBgStyled>}
    {!!tutorial && <TutorialStep {...tutorial}></TutorialStep>}
  </LoadingTutorialWrapper>)
}